import React from 'react'
import './LevelContainer.scss';
import { SubjectButton } from './SubjectButton';

export const LevelContainer = ({ data,subjects, level, updateSubject}) => {

  //console.log(level);
  //console.log(subjects);

  return (
    <div className='level-container'>
        <p>Nivel {level}</p>
        <div className='subjects-container'>
          {Object.keys(subjects).map(key => (<SubjectButton updateSubject={updateSubject} data={data} clave={key} subject={subjects[key]}/>))}
        </div>
    </div>
  )
}
